<div class="carbon-progress-bar-container" [style.width]="width">
    <div class="bx--progress-bar" [class.expired]="expired">
        <div class="bx--progress-bar__track"></div>
        <div class="bx--progress-bar__fill" [style.width.%]="progressValue"
            [class.expired]="expired">
        </div>
    </div>
</div>